import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { MorningScanShipment } from '../../types/MorningScanResponse'

interface InitialState {
  shouldRefetchLastScan?: boolean
  activeShipmentDetails?: MorningScanShipment
  showReturnAcknowledement?: boolean
}

const initialState: InitialState = {
  shouldRefetchLastScan: false,
  activeShipmentDetails: undefined,
  showReturnAcknowledement: false,
}

const slice = createSlice({
  name: 'morningScan',
  initialState,
  reducers: {
    setActiveShipmentDetails: (
      state,
      action: PayloadAction<MorningScanShipment | undefined>,
    ) => {
      state.activeShipmentDetails = action.payload
    },
    setReturnAcknowledgementModal: (state, action: PayloadAction<boolean>) => {
      state.showReturnAcknowledement = action.payload
    },
  },
})

export const { setActiveShipmentDetails, setReturnAcknowledgementModal } =
  slice.actions

export const selectMorningScanState = (state: any) => state.morningScan

export default slice.reducer
